import { HOME } from "@/constants/testIds";

const STEPS = [
  {
    n: "01",
    title: "Paste the job, or open the thread",
    body: "Drop an Upwork job post, a Fiverr brief, or a long client email. MACHA reads context the way you would — only faster.",
  },
  {
    n: "02",
    title: "Pick a goal — win, clarify, or follow up",
    body: "One click chooses the intent. The copilot drafts copy that fits the moment in the conversation, not just the prompt.",
  },
  {
    n: "03",
    title: "Edit in your voice, then send",
    body: "Tweak a line, change the tone, regenerate just one paragraph. MACHA learns your phrasing the more you use it.",
  },
];

export function HowItWorks() {
  return (
    <section
      data-testid={HOME.howItWorks}
      className="border-t border-border bg-card/40"
    >
      <div className="mx-auto w-full max-w-6xl px-5 py-24 sm:px-8 sm:py-32">
        <div className="max-w-2xl">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-primary">
            How it works
          </p>
          <h2 className="mt-3 text-balance text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
            From blank cursor to sent reply in under a minute.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
          {STEPS.map((step, i) => (
            <div
              key={step.n}
              data-testid={HOME.howStep(i + 1)}
              className="relative flex flex-col rounded-2xl border border-border bg-background p-7"
            >
              <span className="font-mono text-[12px] text-muted-foreground">
                {step.n}
              </span>
              <h3 className="mt-5 text-[16px] font-semibold tracking-tight text-foreground">
                {step.title}
              </h3>
              <p className="mt-2 text-[13.5px] leading-relaxed text-muted-foreground">
                {step.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
